/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ruleEngineReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const initialState = {
  ruleSet: [],
};

const ruleEngineReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_RULE_SET:
      return {
        ...state,
        ruleSet: action.payload.error ? [] : action.payload.data,
      };
    case actionType.ADD_RULE_SET:
      return {
        ...state,
        ruleSet: action.payload.error ? [] : action.payload.data,
      };
    default:
      return state;
  }
};

export default ruleEngineReducer;
